import type { Components, Theme } from '@mui/material/styles';

const MuiAlert: Components<Theme>['MuiAlert'] = {
  defaultProps: {
    variant: 'standard'
  },
  styleOverrides: {
    /**
     * Корневые стили алерта
     * @param props Пропсы
     * @param props.theme Тема
     */
    root: ({ theme }) => ({
      borderRadius: theme.shape.borderL,
      fontSize: 12,
      fontFamily: 'Roboto',
      '& .MuiAlert-message': {
        textAlign: 'start',
        padding: '6px 0'
      }
    }),
    /**
     * Стили для стандартного алерта с предупреждением
     * @param props Пропсы
     * @param props.theme - тема
     * @param props.theme.palette - палитра темы
     */
    standardWarning: ({ theme: { palette } }) => ({
      color: palette.warning.dark,
      '& .MuiAlertTitle-root': {
        color: palette.warning.dark
      }
    })
  }
};

const MuiAlertTitle: Components<Theme>['MuiAlertTitle'] = {
  styleOverrides: {
    root: {
      margin: '0 0 2px'
    }
  }
};

export const alert = {
  MuiAlert,
  MuiAlertTitle
} as const;
